import { render, staticRenderFns } from "./MyTaskForm.vue?vue&type=template&id=21126fa2&scoped=true&"
import script from "./MyTaskForm.vue?vue&type=script&lang=js&"
export * from "./MyTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./MyTaskForm.vue?vue&type=style&index=0&id=21126fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21126fa2",
  null
  
)

export default component.exports